import { Box, styled } from '@mui/joy';

const TitleWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
});

export default TitleWrapper;
